
  import { mapState } from 'vuex'
  export default {
    //  开发者协议页面
    name: 'Developer',
    components: {},
    layout: 'template-page',
    asyncData({ app }) {
      app.store.commit('setHightLightHeader', { show: false })
      app.store.commit('setFooterInfo', { show: false })
    },
    head() {
      return {
        title: '开发者协议_问卷网',
      }
    },
    computed: {
      ...mapState(['isMobile', 'innerWidth', 'clientScrollWidth']),
      isShowHeadar() {
        const { innerWidth } = this
        return innerWidth > 640
      },
    },
    watch: {
      isShowHeadar: {
        immediate: true,
        handler(val) {
          this.handleHeaderShow(val)
        },
      },
    },
    methods: {
      // 跳转路由
      jump(url, query) {
        this.$href(url, query)
      },
      handleHeaderShow(val) {
        if (this.isMobile) {
          return
        }
        this.$store.commit('setHightLightHeader', { show: val })
        this.$store.commit('setFooterInfo', { show: val })
      },
    },
  }
